<template>        
    <canvas :id="id"/>
</template>

<script>
import { Chart, registerables, Tooltip } from 'chart.js'

export default {
    props:{
        id: {
            required: true
        },
        data: {
            required: true
        },
        headers: {
            required: true,
        },
        title: {
            required: true
        },
        vertical: {
            type: Boolean,
            default: false
        },
        showLabel: {
            type: Boolean,
            default: true
        }
    },
    created(){
        Chart.register(...registerables);
    },
    mounted(){
        let vm = this;
        vm.Generate();
        vm.UpdateChart();
    },
    watch:{
        data: function(){
            this.UpdateChart();
        }
    },
    data: () => ({
        chart: {},
        head: ""
    }),
    methods:{
        Generate(){
            
            let vm = this;
            const canvas = document.getElementById(this.id);
            const config = {
                type: 'bar',
                options: {
                    indexAxis: this.vertical ? 'x' : 'y',
                    plugins: {
                        tooltip: {
                            callbacks: {
                                title: function(context){
                                    return vm.headers[context[0].dataIndex];
                                },
                                label: function(context){
                                    return "Total: " + context.raw.toDecimal();
                                }
                            }
                        },
                        legend: {
                            display: false,
                            labels: {
                                color: this.$vuetify.theme.dark ? 'white' : 'black'
                            }
                        }
                    },
                    scales: {
                        y: {
                            ticks: {
                                color: this.$vuetify.theme.dark ? 'white' : 'black'
                            },
                            grid: {
                                color: this.$vuetify.theme.dark ? "DimGray" : 'lightgray'
                            }
                        },
                        x: {
                            ticks: {
                                color: this.$vuetify.theme.dark ? 'white' : 'black'
                            }
                        }
                    }                 
                },                
            }

            this.chart = new Chart(canvas, config);
        },
        UpdateChart(){
            if(this.chart){
                this.chart.data.datasets.length = 0;
                this.chart.data.datasets = [
                    {
                        label: this.title,
                        data: this.data,
                        backgroundColor: [
                            'rgba(75, 192, 192, 0.3)',
                            'rgba(255, 99, 132, 0.3)',
                            'rgba(135, 206, 235, 0.3)',
                            'rgba(205, 133, 63, 0.3)',
                            'rgba(128, 128, 128, 0.3)',
                            'rgba(0, 139, 139, 0.3)',
                            'rgba(154, 205, 50, 0.3)',
                            'rgba(54, 162, 235, 0.3)',
                            'rgba(244, 164, 96, 0.3)',
                            'rgba(0, 128, 0, 0.3)',
                            'rgba(255, 206, 86, 0.3)',
                            'rgba(70, 130, 180, 0.3)',
                            'rgba(218, 165, 32, 0.3)',
                            'rgba(153, 102, 255, 0.3)',
                        ],
                        borderColor: 'white',
                        borderWidth: 1
                    }
                ];
                if(this.showLabel){
                    this.chart.data.labels = this.headers;
                }
                else{
                    this.headers.forEach(x => {
                        this.chart.data.labels.push('');
                    });
                }
                this.chart.update();
            }
        }
    }
}
</script>